<script setup lang="ts">
const {
  vorlage,
  modelValue, 
  vorname,
  nachname,
  geburtsdatum,
  heimatort,
  angestelltSeit,
  angestelltBis,
  funktion,
  abteilung,
  bereich,
  teamText,
  team,
  pensum,
  geschlecht,
  disabled,
} = defineProps({
  vorlage: Object,
  modelValue: String,

  vorname: String,
  nachname: String,
  geburtsdatum: String,
  heimatort: String,
  angestelltSeit: String,
  angestelltBis: String,
  funktion: String,
  abteilung: String,
  bereich: String,
  teamText: String,
  team: String,
  pensum: Number,
  geschlecht: String,

  disabled: Boolean,
});

const emit = defineEmits(['update:modelValue', 'ratingData', 'changeMode']);

const replaceVars = (text) => {
  if(vorname)
  text = text.replaceAll("{Vorname}", vorname);

  if(nachname)
  text = text.replaceAll("{Nachname}", nachname);

  if(geburtsdatum)
  text = text.replaceAll("{Geburtsdatum}", geburtsdatum);

  if(heimatort)
  text = text.replaceAll("{Heimatort}", heimatort);

  if(angestelltSeit)
  text = text.replaceAll("{AngestelltSeit}", angestelltSeit);

  if(angestelltBis)
  text = text.replaceAll("{AngestelltBis}", angestelltBis);

  if(funktion)
  text = text.replaceAll("{Funktion}", funktion);

  if(abteilung)
  text = text.replaceAll("{Abteilung}", abteilung);

  if(bereich)
  text = text.replaceAll("{Bereich}", bereich);

  if(pensum)
  text = text.replaceAll("{Pensum}", pensum);

  if(teamText)
  text = text.replaceAll("{TeamText}", teamText);

  if(team)
  text = text.replaceAll("{Team}", team);

  if(geschlecht) {
    text = text.replaceAll("{Er/Sie} ", geschlecht == "m" ? "Er " : "Sie ");
    text = text.replaceAll(" {er/sie}", geschlecht == "m" ? " er" : " sie");
    text = text.replaceAll(" {ihr/ihm}", geschlecht == "m" ? " ihr" : " ihm");
  }

  return text;
}

const undoReplaceVars = (text) => {
  text = text.replaceAll(vorname, '{Vorname}');
  text = text.replaceAll(nachname, '{Nachname}');
  text = text.replaceAll(geburtsdatum, '{Geburtsdatum}');

  if(heimatort)
  text = text.replaceAll(heimatort, '{Heimatort}');

  text = text.replaceAll(angestelltSeit, '{AngestelltSeit}');
  
  if(angestelltBis)
  text = text.replaceAll(angestelltBis, '{AngestelltBis}');

  text = text.replaceAll(funktion, '{Funktion}');
  text = text.replaceAll(abteilung, '{Abteilung}');
  text = text.replaceAll(bereich, '{Bereich}');
  text = text.replaceAll(pensum, '{Pensum}');
  text = text.replaceAll(teamText, '{TeamText}');
  text = text.replaceAll(team, '{Team}');
  
  text = text.replaceAll(geschlecht === 'm' ? 'Er ' : 'Sie ', '{Er/Sie} ')
  text = text.replaceAll(geschlecht === 'm' ? ' er' : ' sie', ' {er/sie}');
  text = text.replaceAll(geschlecht === 'm' ? ' ihm' : ' ihr', ' {ihr/ihm}');

  return text;
}

const keyMonitor = (event) => {

  if(event.altKey) {
    if(event.key >= 1 && event.key <= 4) {
      event.stopPropagation();
      event.preventDefault();

      let newRating = Number(event.key);

      emit('ratingData', {
        newRating: newRating, 
        vorlage: vorlage
      });
    }

    if(event.key === 't') {
      event.stopPropagation();
      event.preventDefault();

      emit('changeMode', {
        mode: 'template', 
        vorlage: vorlage
      });
    }
    if(event.key === 'r') {
      event.stopPropagation();
      event.preventDefault();

      emit('changeMode', {
        mode: 'rechtschreibpruefung', 
        vorlage: vorlage
      });
    }
    if(event.key === 'k') {
      event.stopPropagation();
      event.preventDefault();

      emit('changeMode', {
        mode: 'ki', 
        vorlage: vorlage
      });
    }
  }

}

</script>

<template>
  <textarea
    rows="3"
    class=""
    :value="replaceVars(modelValue)"
    :disabled="disabled"
    :placeholder="disabled ? 'Bitte gib zuerst eine Bewertung ab.' : ''"
    @input="emit('update:modelValue', undoReplaceVars($event.target.value))"
    @keydown="keyMonitor"
  ></textarea>
</template>
